import {
	type RouteProps,
	type match,
	// biome-ignore lint/style/noRestrictedImports: encapsulation
	generatePath as reactRouterDomGeneratePath,
	// biome-ignore lint/style/noRestrictedImports: encapsulation
	matchPath as reactRouterDomMatchPath,
	// biome-ignore lint/style/noRestrictedImports: encapsulation
	useParams as reactRouterDomUseParams,
} from "react-router-dom";

import type { Record } from "~/tools/record";

import type { ExtractPathParams } from "../components/react/link";

export interface Match<TParams> extends Omit<match, "params"> {
	params: TParams;
}

export const matchPath = <
	TPath extends string,
	TParams extends ExtractPathParams<TPath, { parseParamValues: false }> = ExtractPathParams<
		TPath,
		{ parseParamValues: false }
	>,
>(
	url: string,
	props: TPath | Array<TPath> | RouteProps<TPath>,
): null | Match<TParams> => {
	const [pathname] = url.split("?");

	return reactRouterDomMatchPath(pathname, props) as null | Match<TParams>;
};

export const generatePath = <TPath extends string>(
	path: TPath,
	// biome-ignore lint/complexity/noBannedTypes: required for type inference
	...[params]: {} extends ExtractPathParams<TPath>
		? [void | null | undefined | Record<string, never>]
		: [ExtractPathParams<TPath>]
): string => reactRouterDomGeneratePath<string>(path, params as Record<string, string>);

export const useParams = reactRouterDomUseParams as <TPath extends string>() => Partial<
	ExtractPathParams<TPath, { parseParamValues: false }>
>;
